<template>
  <div>
    <v-btn
      v-if="useActivator"
      name="print"
      block
      large
      :disabled="locked"
      @click="print"
    >
      <v-icon v-if="icon">
        {{ IconEnum.printer }}
      </v-icon>
      <span v-else>
        {{ $t('button.ticket.print') }}
      </span>
    </v-btn>

    <!-- *******************************
    ********** PRINTER DIALOG **********
    ******************************** -->
    <ui-dialog
      v-model="dialog"
      :title="$t(isOnError ? 'info.re_print' : 'info.next_print')"
      :use-btn-cancel="isOnError"
      :btn-validate="$t('button.print')"
      @validate="print"
      @hide="ended"
    />
  </div>
</template>

<script>
import { $alert, $bluetoothPrint } from '@/modules/Utils'
import { IconEnum } from '@/modules/Enums'

export default {
  name: 'Printer',

  props: {
    tickets: { type: Array, default: _ => [] },
    qrTicket: { type: String, default: null },
    useActivator: { type: Boolean, default: false },
    icon: { type: Boolean, default: false },
    usePaperCutter: { type: Boolean, default: false },
    startPrinting: { type: Boolean, default: false }
  },

  data () {
    return {
      IconEnum,
      dialog: false,
      locked: false,
      current: 0,
      isOnError: false
    }
  },

  computed: {
    printer () { return this.$store.state.printer }
  },

  mounted () {
    if (this.startPrinting && this.tickets.length > 0) {
      this.print()
    }
  },

  methods: {
    ended () {
      this.dialog = false
      this.current = 0
      this.isOnError = false
      this.$emit('ended')
    },
    print () {
      this.dialog = false
      setTimeout(_ => {
        this.isOnError = false
      }, 1000)

      // Simulation verrouillage bouton imprimer
      this.locked = true
      setTimeout(_ => {
        this.locked = false
      }, 4000)

      if (this.printer !== null && !IS_PAX) {
        // ANDROID Bluetooth printing
        let text = ''
        this.tickets[this.current].Lignes.forEach(line => {
          text += (line.Msg + '\n')
        })
        $bluetoothPrint(this.printer.name, text, this.success, this.error)
      } else if (IS_PAX || IS_CISS_ANDROID || IS_INGENICO || IS_SUNMI) {
        const lines = []
        this.tickets[this.current].Lignes.forEach(line => {
          lines.push({
            text: line.Msg,
            size: line.Taille,
            font: line.Font ? line.Font : 0,
            align: line.Align === 'C' ? 1
              : line.Align === 'R' ? 2 : 0,
            isBold: (line.Gras && line.Gras === 1),
            isUnderline: (line.Souligne && line.Souligne === 1)
          })
        })

        const params = {
          lines: lines,
          image: this.tickets[this.current].Image
        }

        this.$store.commit('loader', this.$i18n.t('loader.printing'))
        CissAndroid.print(params, this.success, this.error)
      } else {
        const printer = document.getElementById('printer')

        for (let i = 0; i < this.tickets.length; i++) {
          // Ligne entre tickets
          if (i > 0) {
            const pre = document.createElement('pre')
            pre.innerText = '------------------------------'
            pre.className = 'my-5 py-5'
            printer.appendChild(pre)
          }

          if (this.tickets[i].Image) {
            const pre = document.createElement('pre')
            pre.className = 'text-center'

            const img = document.createElement('img')
            img.setAttribute('src', this.tickets[i].Image)
            img.setAttribute('alt', 'logo')
            pre.appendChild(img)

            printer.appendChild(pre)
          }

          this.tickets[i].Lignes.forEach(line => {
            // Création ligne
            const pre = document.createElement('pre')
            pre.innerText = line.Msg
            pre.className =
              (line.Align === 'C' ? 'text-center' : (line.Align === 'R' ? 'text-right' : 'text-left')) +
              (line.Taille === 3 ? ' title' : '') +
              (line.Gras === 1 ? ' font-weight-bold' : '') +
              (line.Souligne === 1 ? ' text-decoration-underline' : '') +
              (line.Taille === 3 ? ' title' : '') +
              (line.Font === 1 ? ' font-01' : '')
            // Ajout à la div printer
            printer.appendChild(pre)
          })
        }

        setTimeout(() => {
          cordova.plugins.printer.print()
          printer.innerHTML = ''
        }, 250)
      }
    },
    success () {
      this.current++
      // Si il reste des tickets
      if (this.current < this.tickets.length) {
        if (this.usePaperCutter) {
          // Demande validation pour ticket suivant
          setTimeout(_ => {
            this.$store.commit('loader', false)
            this.dialog = true
          }, 200)
        } else {
          // Impression suivante dans 3 secondes
          setTimeout(this.print, 1000)
        }
      } else {
        // Fin d'impression
        setTimeout(() => {
          this.$store.commit('loader', false)
          this.ended()
        }, 2000)
      }
    },
    error (error) {
      this.$store.commit('loader', false)

      // En cas d'erreur de papier, on réimprime le ticket courant
      const message = error.trim().toLowerCase()
      if (message === 'unsupported') {
        $alert(this.$i18n.t('error.no_printer'), 'info', '', -1,
          this.useActivator ? [{
          title: this.$i18n.t('button.send_by_mail'),
          color: 'success',
          click: () => { this.$emit('send-by-mail') }
        }] : [],
        this.useActivator ? null : () => {
          this.$router.replace({ name: 'ticket', params: { tickets: this.tickets } })
        })
      } else {
        if (message === 'out of paper') {
          $alert(this.$i18n.t('error.no_paper'), 'warning', '', -1)
        } else if (message === 'printer voltage is too low') {
          $alert(this.$i18n.t('error.no_battery'), 'warning', '', -1)
        } else {
          $alert(error)
        }
        setTimeout(_ => {
          this.isOnError = true
          this.dialog = true
        }, 1000)
      }
    }
  }
}
</script>
